export function isInputBlank(input: string | number | boolean | Date | null | undefined): boolean {
  switch (typeof input) {
    case "number": {
      return isNaN(input);
    }
    case "string": {
      return input.length === 0;
    }
    case "boolean": {
      return false;
    }
    default: {
      return true;
    }
  }
}
